import { render, staticRenderFns } from "./AppUpload.vue?vue&type=template&id=0c73fa71&scoped=true&"
import script from "./AppUpload.vue?vue&type=script&lang=js&"
export * from "./AppUpload.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/appstore-simform.css?vue&type=style&index=0&id=0c73fa71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c73fa71",
  null
  
)

export default component.exports